import styled from "styled-components"

const StyledLoadingSpinner = styled.div``

export default StyledLoadingSpinner
